import { DASHBOARD_KEYS } from "../../../../globalConstants";
import AppWrapper from "../../../components/cm/AppWrapper";
import CaseListList from "../../../components/cm/Dashboard/FullPages/CaseList/CaseListList";
import SideBarMain from "../../../components/cm/SideBarMain";
import { MainNavBarEnum } from "../../../components/cm/SideBarMain/MainNavBarEnum";
import { useSaveCurrentNavigation } from "../../../hooks/useSaveCurrentNavigation";

export default () => {
  useSaveCurrentNavigation({ key: DASHBOARD_KEYS.dashboard });

  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain activeRoute={MainNavBarEnum.DASHBOARD} />}>
      <CaseListList
        customBaseDetailPath={"/client-detail/"}
        customBaseDetailSegment={"/client-info/images"}
      />
    </AppWrapper.WithSidebar>
  );
};
